function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as t, jsxs as H, Fragment as _ } from "react/jsx-runtime";
import * as r from "react";
import E from "classnames";
import { SkeletonRectangle as N } from "./skeletons.js";
import { AspectRatioContainer as V } from "./utils/aspect-ratio-support.js";
import { getPrefixedDataAttributes as W } from "./utils/dom.js";
import { useIsInverseVariant as D } from "./theme-variant-context.js";
import { useTheme as O } from "./hooks.js";
import { VIVO_SKIN as P } from "./skins/constants.js";
import { sprinkles as j } from "./sprinkles.css-mistica.js";
import { FADE_IN_DURATION_MS as $, image as U } from "./image.css-mistica.js";
import { vars as o } from "./skins/skin-contract.css-mistica.js";
import { combineRefs as K } from "./utils/common.js";
import Z from "./skeleton-base.js";
const x = /*#__PURE__*/ r.createContext(!0), q = ()=>r.useContext(x), m1 = (param)=>/* @__PURE__ */ {
    let { children: e , value: a  } = param;
    return t(x.Provider, {
        value: a,
        children: e
    });
}, G = (param)=>/* @__PURE__ */ {
    let { style: e  } = param;
    return t("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        style: e,
        children: /* @__PURE__ */ t("path", {
            d: "M24.021 35.7235C24.8145 35.7694 25.0467 36.1913 25.3157 36.5138C25.586 36.8362 29.515 41.551 29.7823 41.8569C30.0475 42.1662 30.7822 42.7329 31.5901 42.8405C32.3967 42.9473 33.282 42.7842 33.8484 42.3748C34.4135 41.965 35.1313 41.4073 35.3833 41.0356C35.6337 40.6638 36.061 40.1302 35.9823 39.2534C35.9028 38.3783 35.7112 37.9204 35.0268 37.1691C34.3433 36.4185 30.2992 31.6657 29.5382 30.7537C29.5382 30.7537 28.8467 29.9423 28.9469 28.7956C29.0476 27.6468 29.567 27.1343 30.6608 26.8487C31.7534 26.5647 36.0267 25.5306 36.0267 25.5306C36.0267 25.5306 38.4728 24.3723 37.9182 22.0776L37.5997 20.904C37.5997 20.904 37.0672 18.2264 33.5519 19.0556C30.0344 19.8869 28.0803 20.377 28.0803 20.377C28.0803 20.377 26.9602 20.4838 26.7999 19.744C26.6417 19.0038 26.8494 18.6218 27.3443 18.4156C27.8387 18.209 30.9611 16.7175 31.3617 12.6853C31.7652 8.65158 28.3882 5.06573 24.0091 5.08104C19.6288 5.0976 16.4594 8.39988 16.4725 11.8185C16.4856 15.2387 18.7033 17.5144 20.4079 18.3638C21.3752 18.8453 21.0656 19.7122 21.0656 19.7122C21.0656 19.7122 20.8334 20.5554 19.8153 20.3311C18.7972 20.1025 13.8657 18.9736 13.8657 18.9736C13.8657 18.9736 10.8914 18.4226 10.1732 21.359C9.4541 24.2978 11.1261 25.4143 12.3532 25.6908C13.5798 25.9669 17.7296 26.9716 17.7296 26.9716C17.7296 26.9716 18.9643 27.581 19.0125 28.8308C19.0425 29.5697 19.0438 30.1824 18.266 31.2832C17.4894 32.3835 12.6598 38.0148 12.6598 38.0148C12.6598 38.0148 10.9997 39.9862 13.4051 41.763C15.8106 43.5401 17.1641 43.1262 18.5921 41.4889C20.0188 39.852 22.8383 36.4243 22.8383 36.4243C22.8383 36.4243 23.2275 35.6788 24.021 35.7235Z",
            stroke: o.colors.brand,
            strokeWidth: "2"
        })
    });
}, J = /*#__PURE__*/ r.forwardRef((param, c)=>{
    let { noBorderRadius: e , circular: a , withIcon: d = !0 , border: l  } = param;
    const s = D(), { skinName: n  } = O();
    return /* @__PURE__ */ t("div", {
        style: {
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: s ? o.colors.backgroundSkeletonInverse : o.colors.backgroundSkeleton,
            boxSizing: "border-box",
            border: l ? `1px solid ${o.colors.borderLow}` : "none",
            borderRadius: a ? "50%" : e ? void 0 : o.borderRadii.container
        },
        ref: c,
        children: d ? n === P ? /* @__PURE__ */ t(G, {
            style: {
                width: "10%",
                minWidth: 24,
                maxWidth: 48
            }
        }) : // We cannot use IconImageRegular because we want to avoid the usage of width and height props to allow this icon to be responsive
        /* @__PURE__ */ t("svg", {
            viewBox: "0 0 24 24",
            role: "presentation",
            style: {
                width: "10%",
                minWidth: 24,
                maxWidth: 48
            },
            children: /* @__PURE__ */ t("path", {
                fill: s ? o.colors.inverse : o.colors.neutralMedium,
                d: "M20.25 4.622c.832 0 1.591.664 1.591 1.393v11.98c0 .728-.76 1.392-1.591 1.392H3.746c-.863 0-1.591-.639-1.591-1.392V6.015c0-.754.728-1.393 1.59-1.393H20.25zm0 13.558c.193 0 .367-.146.39-.207l-.003-11.956a.555.555 0 00-.384-.182H3.746c-.21 0-.364.132-.387.19v11.973c.014.044.171.182.387.182H20.25zM6.152 9.068c0 .554.451 1.005 1.003 1.005a1.006 1.006 0 000-2.01c-.552 0-1.003.45-1.003 1.005zm1.003 2.215a2.216 2.216 0 010-4.43c1.218 0 2.207.993 2.207 2.215a2.213 2.213 0 01-2.207 2.215zm12.42 1.337l-3.18-2.44a.605.605 0 00-.742.005l-3.636 2.9-.879-.83a.6.6 0 00-.798-.025l-5.168 4.317a.607.607 0 00.386 1.07.59.59 0 00.384-.14l4.759-3.975 3.308 3.123c.241.23.625.221.852-.025a.605.605 0 00-.026-.854l-1.932-1.824 3.131-2.496 2.807 2.154a.603.603 0 00.846-.112.609.609 0 00-.112-.848z"
            })
        }) : void 0
    });
}), I = {
    "1:1": 1,
    "16:9": 16 / 9,
    "7:10": 7 / 10,
    "4:3": 4 / 3
}, k = "1:1", Q = /*#__PURE__*/ r.forwardRef((_param, A)=>{
    var { aspectRatio: e = k , alt: a = "" , dataAttributes: d , noBorderRadius: l , src: c , onError: s , onLoad: n , loadingFallback: y = !0 , errorFallback: S = !0  } = _param, i = _object_without_properties(_param, [
        "aspectRatio",
        "alt",
        "dataAttributes",
        "noBorderRadius",
        "src",
        "onError",
        "onLoad",
        "loadingFallback",
        "errorFallback"
    ]);
    const C = r.useRef(), B = q(), z = i.border ? `1px solid ${o.colors.borderLow}` : "none", m = l !== null && l !== void 0 ? l : !B, [f, g] = r.useState(!c), [M, b] = r.useState(!0), [F, R] = r.useState(!1), u = i.circular ? 1 : typeof e == "number" ? e : I[e], w = y && !!(u !== 0 || i.width && i.height), L = S && !!(u !== 0 || i.width && i.height), h = r.useCallback(()=>{
        g(!1), b(!1), setTimeout(()=>{
            R(!0);
        }, $), n == null || n();
    }, [
        n
    ]), T = // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/issues/309
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ t("img", {
        style: _object_spread_props(_object_spread({}, M && w ? {
            opacity: 0
        } : {
            opacity: 1
        }), {
            boxSizing: "border-box",
            border: z
        }),
        ref: K(C, A),
        src: c,
        className: E(U, j({
            position: u !== 0 ? "absolute" : "static",
            borderRadius: i.circular ? "50%" : m ? void 0 : o.borderRadii.container
        })),
        alt: a,
        onError: ()=>{
            g(!0), b(!1), R(!0), s == null || s();
        },
        onLoad: h
    });
    return r.useEffect(()=>{
        var v;
        (v = C.current) != null && v.complete && h();
    }, [
        h
    ]), /* @__PURE__ */ H(_, {
        children: [
            w && !F && /* @__PURE__ */ t("div", {
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                },
                children: i.circular ? /* @__PURE__ */ t(Z, {
                    width: "100%",
                    height: "100%",
                    radius: "50%"
                }) : /* @__PURE__ */ t(N, {
                    width: i.width,
                    height: i.height,
                    noBorderRadius: m
                })
            }),
            f && L && /* @__PURE__ */ t("div", {
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    zIndex: 1
                },
                children: /* @__PURE__ */ t(J, {
                    circular: i.circular,
                    noBorderRadius: m,
                    border: i.border
                })
            }),
            !f && T
        ]
    });
}), X = /*#__PURE__*/ r.forwardRef((e, a)=>{
    var _e_aspectRatio;
    const d = e.circular ? 1 : typeof e.aspectRatio == "number" ? e.aspectRatio : I[(_e_aspectRatio = e.aspectRatio) !== null && _e_aspectRatio !== void 0 ? _e_aspectRatio : k];
    return /* @__PURE__ */ t(V, {
        style: {
            position: "relative"
        },
        aspectRatio: d,
        width: e.width,
        height: e.height,
        dataAttributes: W(e.dataAttributes, "Image"),
        children: /* @__PURE__ */ t(Q, _object_spread_props(_object_spread({}, e), {
            ref: a
        }))
    });
}), u1 = X;
export { Q as ImageContent, J as ImageError, m1 as MediaBorderRadiusProvider, I as RATIO, u1 as default, q as useMediaBorderRadius };
